import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'vector-polygon',
  size: 24,
  node: [
    ['path', { d: 'm12.828 4.813 5.344 2.375', key: 'd72xd9' }],
    ['path', { d: 'm15.769 18.153 3.461-8.306', key: '1m86ed' }],
    ['path', { d: 'm5.687 14.074 7.625 4.852', key: '16trhu' }],
    ['path', { d: 'M9.772 5.579 5.228 11.42', key: '1sledj' }],
    ['circle', { cx: '11', cy: '4', r: '2', key: 'vol9p0' }],
    ['circle', { cx: '15', cy: '20', r: '2', key: '1gio96' }],
    ['circle', { cx: '20', cy: '8', r: '2', key: 'auwzcq' }],
    ['circle', { cx: '4', cy: '13', r: '2', key: 'd2v72u' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name VectorPolygon
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIuODI4IDQuODEzIDUuMzQ0IDIuMzc1IiAvPgogIDxwYXRoIGQ9Im0xNS43NjkgMTguMTUzIDMuNDYxLTguMzA2IiAvPgogIDxwYXRoIGQ9Im01LjY4NyAxNC4wNzQgNy42MjUgNC44NTIiIC8+CiAgPHBhdGggZD0iTTkuNzcyIDUuNTc5IDUuMjI4IDExLjQyIiAvPgogIDxjaXJjbGUgY3g9IjExIiBjeT0iNCIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSIxNSIgY3k9IjIwIiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjIwIiBjeT0iOCIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSI0IiBjeT0iMTMiIHI9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/vector-polygon
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VectorPolygon = createLucideIcon(__iconData);

export default VectorPolygon;
